import { createContext, useContext } from "react";
export const LanguageContext = createContext(undefined);
/**
 * @returns the value of LanguageContext. If there is no LanguageContext at
 * play, this hook will throw an error.
 *
 * Use this if it is _mandatory_ to have a LanguageContext where this hook is used.
 */
export function useLanguage() {
    const value = useContext(LanguageContext);
    if (!value) {
        throw new Error(`useLanguage is used without a LanguageContext. Forgot to add the Provider?`);
    }
    return value;
}
/**
 * @returns the value of LanguageContext, if any exists. Undefined otherwise.
 *
 * Use this if it is _optional_ to have a LanguageContext where this hook is used.
 */
export function useOptionalLanguage() {
    return useContext(LanguageContext);
}
